module.exports = __webpack_public_path__ + "img/bbshomepage6.cf6f8ea0.png";